/**
 * Work Management Service
 * Work tracking and management service API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { HttpParameterCodec, HttpErrorResponse } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import Session from 'supertokens-web-js/recipe/session';
import { AuthStrategy } from '@generator-strategies/auth-strategy';
import { LanguageStrategy } from '@generator-strategies/language-strategy';
import { TenantStrategy } from '@generator-strategies/tenant-strategy';

// @ts-ignore
import { AddCommentRequestDto } from '../model/addCommentRequestDto';
// @ts-ignore
import { AssignWorkItemRequestDto } from '../model/assignWorkItemRequestDto';
// @ts-ignore
import { CancelWorkItemRequestDto } from '../model/cancelWorkItemRequestDto';
// @ts-ignore
import { CompleteWorkItemRequestDto } from '../model/completeWorkItemRequestDto';
// @ts-ignore
import { CreateWorkItemRequestDto } from '../model/createWorkItemRequestDto';
// @ts-ignore
import { PauseWorkItemRequestDto } from '../model/pauseWorkItemRequestDto';
// @ts-ignore
import { ProcessExternalEventRequestDto } from '../model/processExternalEventRequestDto';
// @ts-ignore
import { ResumeWorkItemRequestDto } from '../model/resumeWorkItemRequestDto';
// @ts-ignore
import { SearchRelationshipsByTargetsRequestDto } from '../model/searchRelationshipsByTargetsRequestDto';
// @ts-ignore
import { UpdateWorkItemRequestDto } from '../model/updateWorkItemRequestDto';
// @ts-ignore
import { UpdateWorkItemStatusRequestDto } from '../model/updateWorkItemStatusRequestDto';
// @ts-ignore
import { WorkItemsControllerCreate200Response } from '../model/workItemsControllerCreate200Response';
// @ts-ignore
import { WorkItemsControllerGetHistory200Response } from '../model/workItemsControllerGetHistory200Response';
// @ts-ignore
import { WorkItemsControllerList200Response } from '../model/workItemsControllerList200Response';
// @ts-ignore
import { WorkItemsControllerProcessEvent200Response } from '../model/workItemsControllerProcessEvent200Response';
// @ts-ignore
import { WorkItemsControllerSearchRelationshipsByTargetsGet200Response } from '../model/workItemsControllerSearchRelationshipsByTargetsGet200Response';
// @ts-ignore
import { WorkItemsControllerSearchRelationshipsByTargetsPost200Response } from '../model/workItemsControllerSearchRelationshipsByTargetsPost200Response';

// @ts-ignore
import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class WorkItemsService {
  protected basePath = 'http://localhost';
  public defaultHeaders: any = {};
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    @Optional()@Inject(BASE_PATH) basePath: string|string[],
    @Optional() configuration: Configuration,
    @Optional() private readonly authStrategy: AuthStrategy,
    @Optional() private readonly languageStrategy: LanguageStrategy,
    @Optional() private readonly tenantStrategy: TenantStrategy,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }


  /**
   * Add comment to work item
   * @param workItemId
   * @param addCommentRequestDto
   */
  public async workItemsControllerAddComment(workItemId: string, addCommentRequestDto: AddCommentRequestDto, ): Promise<WorkItemsControllerCreate200Response> {
    if (workItemId === null || workItemId === undefined) {
      throw new Error('Required parameter workItemId was null or undefined when calling workItemsControllerAddComment.');
    }
    if (addCommentRequestDto === null || addCommentRequestDto === undefined) {
      throw new Error('Required parameter addCommentRequestDto was null or undefined when calling workItemsControllerAddComment.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-work-management/work-items/${this.configuration.encodeParam({name: "workItemId", value: workItemId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/comments`,
        data: addCommentRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Assign work item
   * @param workItemId
   * @param forceUpdate
   * @param assignWorkItemRequestDto
   */
  public async workItemsControllerAssign(workItemId: string, forceUpdate: string, assignWorkItemRequestDto: AssignWorkItemRequestDto, ): Promise<WorkItemsControllerCreate200Response> {
    if (workItemId === null || workItemId === undefined) {
      throw new Error('Required parameter workItemId was null or undefined when calling workItemsControllerAssign.');
    }
    if (forceUpdate === null || forceUpdate === undefined) {
      throw new Error('Required parameter forceUpdate was null or undefined when calling workItemsControllerAssign.');
    }
    if (assignWorkItemRequestDto === null || assignWorkItemRequestDto === undefined) {
      throw new Error('Required parameter assignWorkItemRequestDto was null or undefined when calling workItemsControllerAssign.');
    }

    const localVarQueryParameters = new URLSearchParams();
    if (forceUpdate !== undefined && forceUpdate !== null) {
      localVarQueryParameters.append('forceUpdate', String(forceUpdate));
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-work-management/work-items/${this.configuration.encodeParam({name: "workItemId", value: workItemId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/assign?${queryString}` : `${this.configuration.basePath}/api/forthbridge-work-management/work-items/${this.configuration.encodeParam({name: "workItemId", value: workItemId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/assign`;
    const response = await CapacitorHttp.post({
      url: urlWithParams,
        data: assignWorkItemRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Cancel work item
   * @param workItemId
   * @param forceUpdate
   * @param cancelWorkItemRequestDto
   */
  public async workItemsControllerCancel(workItemId: string, forceUpdate: string, cancelWorkItemRequestDto: CancelWorkItemRequestDto, ): Promise<WorkItemsControllerCreate200Response> {
    if (workItemId === null || workItemId === undefined) {
      throw new Error('Required parameter workItemId was null or undefined when calling workItemsControllerCancel.');
    }
    if (forceUpdate === null || forceUpdate === undefined) {
      throw new Error('Required parameter forceUpdate was null or undefined when calling workItemsControllerCancel.');
    }
    if (cancelWorkItemRequestDto === null || cancelWorkItemRequestDto === undefined) {
      throw new Error('Required parameter cancelWorkItemRequestDto was null or undefined when calling workItemsControllerCancel.');
    }

    const localVarQueryParameters = new URLSearchParams();
    if (forceUpdate !== undefined && forceUpdate !== null) {
      localVarQueryParameters.append('forceUpdate', String(forceUpdate));
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-work-management/work-items/${this.configuration.encodeParam({name: "workItemId", value: workItemId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/cancel?${queryString}` : `${this.configuration.basePath}/api/forthbridge-work-management/work-items/${this.configuration.encodeParam({name: "workItemId", value: workItemId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/cancel`;
    const response = await CapacitorHttp.post({
      url: urlWithParams,
        data: cancelWorkItemRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Complete work item
   * @param workItemId
   * @param forceUpdate
   * @param completeWorkItemRequestDto
   */
  public async workItemsControllerComplete(workItemId: string, forceUpdate: string, completeWorkItemRequestDto: CompleteWorkItemRequestDto, ): Promise<WorkItemsControllerCreate200Response> {
    if (workItemId === null || workItemId === undefined) {
      throw new Error('Required parameter workItemId was null or undefined when calling workItemsControllerComplete.');
    }
    if (forceUpdate === null || forceUpdate === undefined) {
      throw new Error('Required parameter forceUpdate was null or undefined when calling workItemsControllerComplete.');
    }
    if (completeWorkItemRequestDto === null || completeWorkItemRequestDto === undefined) {
      throw new Error('Required parameter completeWorkItemRequestDto was null or undefined when calling workItemsControllerComplete.');
    }

    const localVarQueryParameters = new URLSearchParams();
    if (forceUpdate !== undefined && forceUpdate !== null) {
      localVarQueryParameters.append('forceUpdate', String(forceUpdate));
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-work-management/work-items/${this.configuration.encodeParam({name: "workItemId", value: workItemId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/complete?${queryString}` : `${this.configuration.basePath}/api/forthbridge-work-management/work-items/${this.configuration.encodeParam({name: "workItemId", value: workItemId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/complete`;
    const response = await CapacitorHttp.post({
      url: urlWithParams,
        data: completeWorkItemRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Create a work item
   * @param createWorkItemRequestDto
   */
  public async workItemsControllerCreate(createWorkItemRequestDto: CreateWorkItemRequestDto, ): Promise<WorkItemsControllerCreate200Response> {
    if (createWorkItemRequestDto === null || createWorkItemRequestDto === undefined) {
      throw new Error('Required parameter createWorkItemRequestDto was null or undefined when calling workItemsControllerCreate.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-work-management/work-items`,
        data: createWorkItemRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Get work item by ID
   * @param workItemId
   * @param expand Fields to expand in the response
   */
  public async workItemsControllerGetById(workItemId: string, expand?: Array<'children' | 'comments' | 'history' | 'parent' | 'event-log' | 'work-type'>, ): Promise<WorkItemsControllerCreate200Response> {
    if (workItemId === null || workItemId === undefined) {
      throw new Error('Required parameter workItemId was null or undefined when calling workItemsControllerGetById.');
    }

    const localVarQueryParameters = new URLSearchParams();
      if (expand) {
        expand.forEach((element) => {
          localVarQueryParameters.append('expand', String(element));
        });
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-work-management/work-items/${this.configuration.encodeParam({name: "workItemId", value: workItemId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}?${queryString}` : `${this.configuration.basePath}/api/forthbridge-work-management/work-items/${this.configuration.encodeParam({name: "workItemId", value: workItemId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
    const response = await CapacitorHttp.get({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Get work item history
   * @param workItemId
   */
  public async workItemsControllerGetHistory(workItemId: string, ): Promise<WorkItemsControllerGetHistory200Response> {
    if (workItemId === null || workItemId === undefined) {
      throw new Error('Required parameter workItemId was null or undefined when calling workItemsControllerGetHistory.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/forthbridge-work-management/work-items/${this.configuration.encodeParam({name: "workItemId", value: workItemId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/history`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * List work items
   * @param elementId Filter by work type element ID
   * @param status Filter by status (multiple values supported)
   * @param statusReason Filter by status reason code
   * @param assignedTo Filter by assignee ID
   * @param priority Filter by priority
   * @param patientId Filter by patient ID in metadata
   * @param parentWorkItemId Filter by parent work item ID
   * @param parentOnly When true, returns only top-level work items (those without a parent)
   * @param targetAudience Filter by target audience
   * @param expand Fields to expand in the response
   * @param startDate Start date for date range filter
   * @param endDate End date for date range filter
   * @param sort Sort field
   * @param sortDirection Sort direction
   * @param limit Number of items to return
   * @param offset Number of items to skip
   */
  public async workItemsControllerList(elementId?: string, status?: Array<'open' | 'closed' | 'on-hold'>, statusReason?: string, assignedTo?: string, priority?: 'low' | 'medium' | 'high' | 'urgent', patientId?: string, parentWorkItemId?: string, parentOnly?: boolean, targetAudience?: 'user' | 'patient', expand?: Array<'children' | 'comments' | 'history' | 'parent' | 'event-log' | 'work-type'>, startDate?: string, endDate?: string, sort?: 'createdOn' | 'updatedOn' | 'priority', sortDirection?: 'ASC' | 'DESC', limit?: number, offset?: number, ): Promise<WorkItemsControllerList200Response> {

    const localVarQueryParameters = new URLSearchParams();
    if (elementId !== undefined && elementId !== null) {
      localVarQueryParameters.append('elementId', String(elementId));
    }
      if (status) {
        status.forEach((element) => {
          localVarQueryParameters.append('status', String(element));
        });
    }
    if (statusReason !== undefined && statusReason !== null) {
      localVarQueryParameters.append('statusReason', String(statusReason));
    }
    if (assignedTo !== undefined && assignedTo !== null) {
      localVarQueryParameters.append('assignedTo', String(assignedTo));
    }
    if (priority !== undefined && priority !== null) {
      localVarQueryParameters.append('priority', String(priority));
    }
    if (patientId !== undefined && patientId !== null) {
      localVarQueryParameters.append('patientId', String(patientId));
    }
    if (parentWorkItemId !== undefined && parentWorkItemId !== null) {
      localVarQueryParameters.append('parentWorkItemId', String(parentWorkItemId));
    }
    if (parentOnly !== undefined && parentOnly !== null) {
      localVarQueryParameters.append('parentOnly', String(parentOnly));
    }
    if (targetAudience !== undefined && targetAudience !== null) {
      localVarQueryParameters.append('targetAudience', String(targetAudience));
    }
      if (expand) {
        expand.forEach((element) => {
          localVarQueryParameters.append('expand', String(element));
        });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters.append('startDate', String(startDate));
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters.append('endDate', String(endDate));
    }
    if (sort !== undefined && sort !== null) {
      localVarQueryParameters.append('sort', String(sort));
    }
    if (sortDirection !== undefined && sortDirection !== null) {
      localVarQueryParameters.append('sortDirection', String(sortDirection));
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters.append('limit', String(limit));
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters.append('offset', String(offset));
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-work-management/work-items?${queryString}` : `${this.configuration.basePath}/api/forthbridge-work-management/work-items`;
    const response = await CapacitorHttp.get({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Pause work item
   * @param workItemId
   * @param forceUpdate
   * @param pauseWorkItemRequestDto
   */
  public async workItemsControllerPause(workItemId: string, forceUpdate: string, pauseWorkItemRequestDto: PauseWorkItemRequestDto, ): Promise<WorkItemsControllerCreate200Response> {
    if (workItemId === null || workItemId === undefined) {
      throw new Error('Required parameter workItemId was null or undefined when calling workItemsControllerPause.');
    }
    if (forceUpdate === null || forceUpdate === undefined) {
      throw new Error('Required parameter forceUpdate was null or undefined when calling workItemsControllerPause.');
    }
    if (pauseWorkItemRequestDto === null || pauseWorkItemRequestDto === undefined) {
      throw new Error('Required parameter pauseWorkItemRequestDto was null or undefined when calling workItemsControllerPause.');
    }

    const localVarQueryParameters = new URLSearchParams();
    if (forceUpdate !== undefined && forceUpdate !== null) {
      localVarQueryParameters.append('forceUpdate', String(forceUpdate));
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-work-management/work-items/${this.configuration.encodeParam({name: "workItemId", value: workItemId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/pause?${queryString}` : `${this.configuration.basePath}/api/forthbridge-work-management/work-items/${this.configuration.encodeParam({name: "workItemId", value: workItemId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/pause`;
    const response = await CapacitorHttp.post({
      url: urlWithParams,
        data: pauseWorkItemRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Process external event
   * @param processExternalEventRequestDto
   */
  public async workItemsControllerProcessEvent(processExternalEventRequestDto: ProcessExternalEventRequestDto, ): Promise<WorkItemsControllerProcessEvent200Response> {
    if (processExternalEventRequestDto === null || processExternalEventRequestDto === undefined) {
      throw new Error('Required parameter processExternalEventRequestDto was null or undefined when calling workItemsControllerProcessEvent.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-work-management/work-items/events/process`,
        data: processExternalEventRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Resume work item
   * @param workItemId
   * @param resumeWorkItemRequestDto
   */
  public async workItemsControllerResume(workItemId: string, resumeWorkItemRequestDto: ResumeWorkItemRequestDto, ): Promise<WorkItemsControllerCreate200Response> {
    if (workItemId === null || workItemId === undefined) {
      throw new Error('Required parameter workItemId was null or undefined when calling workItemsControllerResume.');
    }
    if (resumeWorkItemRequestDto === null || resumeWorkItemRequestDto === undefined) {
      throw new Error('Required parameter resumeWorkItemRequestDto was null or undefined when calling workItemsControllerResume.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-work-management/work-items/${this.configuration.encodeParam({name: "workItemId", value: workItemId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/resume`,
        data: resumeWorkItemRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Search work item relationships by target IDs and entity
   * Returns all relationships matching any of the provided target IDs for the specified entity type, including their associated work items
   * @param targetIds Comma-separated target IDs to search for
   * @param targetEntity Target entity type (e.g., CarePlan, Order, Task)
   * @param statuses Filter by work item statuses (comma-separated)
   * @param targetAudience Filter by target audience (provider or patient)
   */
  public async workItemsControllerSearchRelationshipsByTargetsGet(targetIds: string, targetEntity: string, statuses?: string, targetAudience?: 'user' | 'patient', ): Promise<WorkItemsControllerSearchRelationshipsByTargetsGet200Response> {
    if (targetIds === null || targetIds === undefined) {
      throw new Error('Required parameter targetIds was null or undefined when calling workItemsControllerSearchRelationshipsByTargetsGet.');
    }
    if (targetEntity === null || targetEntity === undefined) {
      throw new Error('Required parameter targetEntity was null or undefined when calling workItemsControllerSearchRelationshipsByTargetsGet.');
    }

    const localVarQueryParameters = new URLSearchParams();
    if (targetIds !== undefined && targetIds !== null) {
      localVarQueryParameters.append('targetIds', String(targetIds));
    }
    if (targetEntity !== undefined && targetEntity !== null) {
      localVarQueryParameters.append('targetEntity', String(targetEntity));
    }
    if (statuses !== undefined && statuses !== null) {
      localVarQueryParameters.append('statuses', String(statuses));
    }
    if (targetAudience !== undefined && targetAudience !== null) {
      localVarQueryParameters.append('targetAudience', String(targetAudience));
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-work-management/work-items/search-by-targets?${queryString}` : `${this.configuration.basePath}/api/forthbridge-work-management/work-items/search-by-targets`;
    const response = await CapacitorHttp.get({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Search work items by multiple targets
   * Returns paginated work items with their matching relationships for the provided targets (id + entity pairs), supporting multiple entity types
   * @param searchRelationshipsByTargetsRequestDto
   */
  public async workItemsControllerSearchRelationshipsByTargetsPost(searchRelationshipsByTargetsRequestDto: SearchRelationshipsByTargetsRequestDto, ): Promise<WorkItemsControllerSearchRelationshipsByTargetsPost200Response> {
    if (searchRelationshipsByTargetsRequestDto === null || searchRelationshipsByTargetsRequestDto === undefined) {
      throw new Error('Required parameter searchRelationshipsByTargetsRequestDto was null or undefined when calling workItemsControllerSearchRelationshipsByTargetsPost.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-work-management/work-items/search-by-targets`,
        data: searchRelationshipsByTargetsRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Update work item
   * @param workItemId
   * @param forceUpdate
   * @param updateWorkItemRequestDto
   */
  public async workItemsControllerUpdate(workItemId: string, forceUpdate: string, updateWorkItemRequestDto: UpdateWorkItemRequestDto, ): Promise<WorkItemsControllerCreate200Response> {
    if (workItemId === null || workItemId === undefined) {
      throw new Error('Required parameter workItemId was null or undefined when calling workItemsControllerUpdate.');
    }
    if (forceUpdate === null || forceUpdate === undefined) {
      throw new Error('Required parameter forceUpdate was null or undefined when calling workItemsControllerUpdate.');
    }
    if (updateWorkItemRequestDto === null || updateWorkItemRequestDto === undefined) {
      throw new Error('Required parameter updateWorkItemRequestDto was null or undefined when calling workItemsControllerUpdate.');
    }

    const localVarQueryParameters = new URLSearchParams();
    if (forceUpdate !== undefined && forceUpdate !== null) {
      localVarQueryParameters.append('forceUpdate', String(forceUpdate));
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-work-management/work-items/${this.configuration.encodeParam({name: "workItemId", value: workItemId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}?${queryString}` : `${this.configuration.basePath}/api/forthbridge-work-management/work-items/${this.configuration.encodeParam({name: "workItemId", value: workItemId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
    const response = await CapacitorHttp.patch({
      url: urlWithParams,
        data: updateWorkItemRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Update work item status
   * @param workItemId
   * @param forceUpdate
   * @param updateWorkItemStatusRequestDto
   */
  public async workItemsControllerUpdateStatus(workItemId: string, forceUpdate: string, updateWorkItemStatusRequestDto: UpdateWorkItemStatusRequestDto, ): Promise<WorkItemsControllerCreate200Response> {
    if (workItemId === null || workItemId === undefined) {
      throw new Error('Required parameter workItemId was null or undefined when calling workItemsControllerUpdateStatus.');
    }
    if (forceUpdate === null || forceUpdate === undefined) {
      throw new Error('Required parameter forceUpdate was null or undefined when calling workItemsControllerUpdateStatus.');
    }
    if (updateWorkItemStatusRequestDto === null || updateWorkItemStatusRequestDto === undefined) {
      throw new Error('Required parameter updateWorkItemStatusRequestDto was null or undefined when calling workItemsControllerUpdateStatus.');
    }

    const localVarQueryParameters = new URLSearchParams();
    if (forceUpdate !== undefined && forceUpdate !== null) {
      localVarQueryParameters.append('forceUpdate', String(forceUpdate));
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-work-management/work-items/${this.configuration.encodeParam({name: "workItemId", value: workItemId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/status?${queryString}` : `${this.configuration.basePath}/api/forthbridge-work-management/work-items/${this.configuration.encodeParam({name: "workItemId", value: workItemId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/status`;
    const response = await CapacitorHttp.patch({
      url: urlWithParams,
        data: updateWorkItemStatusRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
}
